/**
 * Date Utils
 */

const DateUtils = {
  /**
   * Format a given numeric timestamp as a time string
   * @param {Number} t timestamp in miliseconds
   * @param {String} f format string
   */  
  format: function(t, f) {
    let result = '0';
    let date = null;
    let H = null;
    let m = null;
    let s = null;
    let ms = null;
    switch (f) {
      case 'HH:mm':
        date = new Date(t);
        H = `0${date.getHours()}`.slice(-2);
        m = `0${date.getMinutes()}`.slice(-2);
        return `${H}:${m}`;
      case 'HH:mm:ss.ff':
        date = new Date(t);
        H = `0${date.getHours()}`.slice(-2);
        m = `0${date.getMinutes()}`.slice(-2);
        s = `0${date.getSeconds()}`.slice(-2);
        ms = `0000${date.getMilliseconds()}`.slice(-4);
        return `${H}:${m}:${s}.${ms}`;
      default:
        return result;
    }
  },
};

export default DateUtils;


// WEBPACK FOOTER //
// ../UmiCore/src/utils/DateUtils.js